import type { ParsedLocation } from "@tanstack/react-router";
import { create } from "zustand";
import type { TStoreNavAnchorNames } from "../pages/Store/components/StoreNav";
import { STORE_NAV_ITEMS } from "../pages/Store/types/TStore";

export type TStoreNavItemsState = "loading" | "unavailable" | HTMLElement;
type TStoreNavItemsStatus = Record<TStoreNavAnchorNames, TStoreNavItemsState>;

interface PrevLocationParams {id: string | null, name: string | null, category: string | null}

interface NavigationStore {
  analyticsPrevLocation: PrevLocationParams;
  setAnalyticsPrevLocation: (params: PrevLocationParams) => void;
  previousLocation: ParsedLocation | null;
  setPreviousLocation: (loc: ParsedLocation | null) => void;
  activeStoreSectionAnchor: TStoreNavAnchorNames | null;
  setActiveStoreSectionAnchor: (anchor: TStoreNavAnchorNames | null) => void;
  storeNavItemsState: TStoreNavItemsStatus;
  setStoreNavItemsState: (item: TStoreNavAnchorNames, state: TStoreNavItemsState) => void;
  resetAllStoreNavItemsState: () => void;
  isAddToHomeHeaderVisible: boolean;
  setIsAddToHomeHeaderVisible: (bool: boolean) => void;
}

const storeNavItemsStateInitialValue = Object.fromEntries(
  STORE_NAV_ITEMS.map((it) => [it, "loading"]),
) as TStoreNavItemsStatus;

export const useNavigationStore = create<NavigationStore>((set) => ({
  analyticsPrevLocation: { id: null, name: null, category: null},
  setAnalyticsPrevLocation: ({id, name, category}: PrevLocationParams) => set({ analyticsPrevLocation: {id, name, category} }),
  previousLocation: null,
  activeStoreSectionAnchor: null,
  storeNavItemsState: storeNavItemsStateInitialValue,
  isAddToHomeHeaderVisible: false,
  setPreviousLocation: (previousLocation) => set({ previousLocation }),
  setActiveStoreSectionAnchor: (activeStoreSectionAnchor) => set({ activeStoreSectionAnchor }),
  setStoreNavItemsState: (item, state) =>
    set((s) => ({ storeNavItemsState: { ...s.storeNavItemsState, [item]: state } })),
  resetAllStoreNavItemsState: () =>
    set({
      storeNavItemsState: storeNavItemsStateInitialValue,
    }),
  setIsAddToHomeHeaderVisible: (isAddToHomeHeaderVisible) => set({ isAddToHomeHeaderVisible }),
}));
